import {
    Component
} from '@angular/core';
import {
    ADMIN_BANNERS_PAGE,
    ADMIN_CATEGORIAS_PAGE,
    ADMIN_PRODUCTOS_PAGE,
    ADMIN_CONFIGURACIONES_PAGE,
    ADMIN_SUCURSALES_PAGE,
    ADMIN_PEDIDOS_PAGE,
    ADMIN_PROMOCIONALES_PAGE
} from '../../pages/pages.constants';
import {
    App
} from 'ionic-angular';

@Component({
    selector: 'subheader',
    templateUrl: 'subheader.html'
})
export class SubheaderComponent {
    private pages: Array < any > = [{
            title: 'Sucursales',
            component: ADMIN_SUCURSALES_PAGE
        }, {
            title: 'Banners',
            component: ADMIN_BANNERS_PAGE
        }, {
            title: 'Videos',
            component: ADMIN_PROMOCIONALES_PAGE
        }, {
            title: 'Categorías',
            component: ADMIN_CATEGORIAS_PAGE
        }, {
            title: 'Productos',
            component: ADMIN_PRODUCTOS_PAGE
        }, {
            title: 'Pedidos',
            component: ADMIN_PEDIDOS_PAGE
        }
        // , {
        //     title: 'Ajustes',
        //     component: ADMIN_CONFIGURACIONES_PAGE
        // }
    ];

    constructor(private _app: App) {}

    openPage(page) {
        this._app.getRootNavs()[0].setRoot(page.component);
    }
}


// WEBPACK FOOTER //
// ./src/components/subheader/subheader.ts